// extracted by mini-css-extract-plugin
export default {"review":"bpym9_","empty":"g1KPvO"};